import React, { useState, useEffect } from 'react';
import { fetchConToken } from 'helpers/fetch';
import { getDataSession } from 'views/Utils/Common';
import { currency } from 'resources/utilities';
import ListTable from 'components/table/ListTable';
import TextField from '@mui/material/TextField';
import RenderButtons from 'components/table/RenderButtons';
import Modal from 'components/modal/Modal';
import { useModal } from 'hooks/useModal';
import { useUIUtils } from 'hooks/useUIUtils';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import AsyncSelect from 'react-select/async';
import Swal from 'sweetalert2';

const List = ({ history, match }) => {
    const { path } = match;
    const [fechaInicio, setFechaInicio] = useState(GetFecha(true));
    const [fechaFin, setFechaFin] = useState(GetFecha(false));
    const [actualizarTabla,] = useState(false);
    const { changeGlobalTitle } = useUIUtils()
    let [vxVisita, setVxVisita] = useState({});
    let [filtro, setFiltro] = useState('T');
    let [filtroFecha, setFiltroFecha] = useState('0');
    let [agente, setAgente] = useState(0);
    let [tipoVisita, setTipoVisita] = useState(0);
    const [modalKey, setModalKey] = useState(0);
    const [tipoVisitas, setTipoVisitas] = useState([]);
    const [isOpenModal, openModal, closeModal] = useModal(false);

    const verVisitas = (visita_id) => {
        setModalKey(prev => prev + 1);
        fetchConToken(`VxVisitas?id=${visita_id}`).then(resp => setVxVisita(resp));
        openModal();
    }

    const columns = [
        { renderCell: RenderButtons, type: 'actions', headerName: '', maxWidth: 20, path: path, opciones: "verVisitas", verVisitas: verVisitas },
        { field: 'nombre_Cliente', headerName: 'Cliente', minWidth: 185 },
        { field: 'nombre_Agente', headerName: 'Agente', minWidth: 185 },
        { field: 'vx_TipoVisita', headerName: 'Tipo Visita', minWidth: 120, renderCell: ({ value }) => GetTipoVisita(value) },
        { field: 'fecha_Planeada', headerName: 'Fecha Planeada', minWidth: 120, renderCell: ({ value }) => value?.substring(0, 10) },
        { field: 'fecha_Hora_Inicial', headerName: 'Hora Inicial', minWidth: 120 },
        { field: 'fecha_Hora_Final', headerName: 'Hora Final', minWidth: 120 },
        { field: 'razon_Vis_Infec', headerName: 'Razon Vis. Inecf.', minWidth: 130 },
        { field: 'importe_Cobros', headerName: 'Importe cobros', minWidth: 110, type: 'number', renderCell: ({ value }) => currency(value) },
        { field: 'importe_Pedidos', headerName: 'Importe Pedidos', minWidth: 115, type: 'number', renderCell: ({ value }) => currency(value) },
        { field: 'movimientos', headerName: 'Movimientos', minWidth: 120 },
        { field: 'observaciones', headerName: 'Observaciones', minWidth: 200 },
    ];

    useEffect(() => {
        const loadTipoVisita = async (query) => {
            if (getDataSession('sucursal') === '0') {
                Swal.fire('Info', 'Seleccione una conexión para continuar.', 'info');
                return;
            }

            var resp = await fetchConToken(`VxTipoVisita/GetList?paginas=0&totalXpagina=50&busqueda=${query}&sucursal_Id=${getDataSession('sucursal')}`);
            setTipoVisitas(resp?.data || []);
        }

        changeGlobalTitle("Visitas", 'Listado de Visitas');
        loadTipoVisita('');
    }, [changeGlobalTitle, setTipoVisitas]);

    const handleInputChangeFechaInicio = ({ target }) => {
        setFechaInicio(target.value);
    };

    const handleInputChangeFechaFin = ({ target }) => {
        setFechaFin(target.value);
    }

    function handleChangeFiltros(e) {
        setFiltro(e.target.value);
    }

    function handleChangeTipoVisita(e) {
        setTipoVisita(e.target.value);
    }

    function handleChangeFiltroFecha(e) {
        setFiltroFecha(e.target.value);
    }

    function GetFecha(inicio) {
        var curr = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
        if (!inicio) curr = new Date(curr.getFullYear(), curr.getMonth(), new Date(curr.getFullYear(), curr.getMonth() + 1, 0).getDate());

        curr.setDate(curr.getDate());
        return curr.toISOString().substring(0, 10);
    }

    const loadAgentes = async (query) => {
        if (getDataSession('sucursal') === '0') {
            Swal.fire('Info', 'Seleccione una conexión para continuar.', 'info');
            return;
        }

        var resp = await fetchConToken(`usuarios/GetList?paginas=0&totalXpagina=50&busqueda=${query}&sucursal_Id=${getDataSession('sucursal')}&tipoUsuario=AGENTE`);
        return resp.data;
    };

    const GetTipoVisita = (item) => {
        if (!(item && item !== undefined && item !== null)) return "";

        return item.clave + " - " + item.nombre;
    }

    return (<>
        <div className='espacio10px' />
        <div className='container-fluid'>
            <div className='row align-items-end g-3 mb-3'>
                {/*<div className='col-sm-2'>
                        <Link to={`${path}/add`} className='btn btn-outline-primary m-1' style={{ width: 'auto' }}>
                            <svg
                                xmlns='http://www.w3.org/2000/svg'
                                width='18'
                                height='18'
                                fill='currentColor'
                                className='bi bi-plus-square'
                                viewBox='0 0 16 16'
                            >
                                <path d='M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z' />
                                <path d='M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z' />
                            </svg>
                            &nbsp; {t('app.SwalFire.nuevo')}
                        </Link>
                    </div>*/}
                <div className='col-12 col-lg-2 col-md-6'>
                    <label className='form-label mb-1' style={{ fontSize: '14px', fontWeight: 500 }}>Agente</label>
                    <AsyncSelect
                        placeholder='&nbsp; Agente'
                        aria-label='Gente'
                        isClearable
                        styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            control: (base) => ({ ...base, minHeight: '38px' })
                        }}
                        getOptionLabel={(option) => 'Agente:' + option.nombre + ' - ' + option.correo}
                        getOptionValue={(option) => option.id}
                        loadOptions={loadAgentes}
                        onChange={(selectedItem) => setAgente((selectedItem !== undefined && selectedItem !== null) ? selectedItem?.id.toString() : 0)}
                    />
                </div>
                <div className='col-12 col-lg-2 col-md-6'>
                    <FormControl fullWidth size="small">
                        <InputLabel id="almacen-multiple-checkbox-label">Filtros</InputLabel>
                        <Select
                            labelId="almacen-multiple-checkbox-label"
                            id="almacen-multiple-checkbox"
                            onChange={handleChangeFiltros}
                            value={filtro}
                            label="Filtros"
                        >
                            <MenuItem key="TodosFiltros" value="T">
                                <ListItemText primary="Todos" />
                            </MenuItem>
                            <MenuItem key="Asignados" value="P">
                                <ListItemText primary="Planeado" />
                            </MenuItem>
                            <MenuItem key="NoAsignados" value="N" va>
                                <ListItemText primary="No Planeado" />
                            </MenuItem>
                        </Select>
                    </FormControl>
                </div>
                <div className='col-12 col-lg-2 col-md-6'>
                    <FormControl fullWidth size="small">
                        <InputLabel id="almacen-multiple-checkbox-label">Tipo Visita</InputLabel>
                        <Select
                            labelId="almacen-multiple-checkbox-label"
                            id="almacen-multiple-checkbox"
                            onChange={handleChangeTipoVisita}
                            value={tipoVisita}
                            label="Tipo Visita"
                        >
                            <MenuItem key="TodosTipoVisita" value="0">
                                <ListItemText primary="Todos" />
                            </MenuItem>
                            {tipoVisitas?.map((item) => { return (<MenuItem key={item.clave} value={item.id}><ListItemText primary={GetTipoVisita(item)} /></MenuItem>); })}
                        </Select>
                    </FormControl>
                </div>
                <div className='col-12 col-lg-2 col-md-6'>
                    <FormControl fullWidth size="small">
                        <InputLabel id="almacen-multiple-checkbox-label">Filtro Fecha</InputLabel>
                        <Select
                            labelId="almacen-multiple-checkbox-label"
                            id="almacen-multiple-checkbox"
                            onChange={handleChangeFiltroFecha}
                            value={filtroFecha}
                            label="Filtro Fecha"
                        >
                            <MenuItem key="FechaCreacion" value="0">
                                <ListItemText primary="Fecha Creacion" />
                            </MenuItem>
                            <MenuItem key="FechaPlaneada" value="1">
                                <ListItemText primary="Fecha Planeada" />
                            </MenuItem>
                            <MenuItem key="FechaVisista" value="2" va>
                                <ListItemText primary="Fecha Visita" />
                            </MenuItem>
                        </Select>
                    </FormControl>
                </div>
                <div className='col-12 col-lg-4 col-md-6'>
                    <div className='row g-2'>
                        <div className='col-12 col-sm-6'>
                            <TextField
                                fullWidth
                                size="small"
                                id="fecha-inicio"
                                label="Fecha Inicio"
                                type="date"
                                value={fechaInicio}
                                onChange={handleInputChangeFechaInicio}
                                InputLabelProps={{ shrink: true }}
                            />
                        </div>
                        <div className='col-12 col-sm-6'>
                            <TextField
                                fullWidth
                                size="small"
                                id="fecha-fin"
                                label="Fecha Fin"
                                type="date"
                                value={fechaFin}
                                onChange={handleInputChangeFechaFin}
                                InputLabelProps={{ shrink: true }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className='col-md-12'>
                <ListTable
                    columns={columns}
                    path={path}
                    hideSearch={true}
                    reload={actualizarTabla}
                    url={`VxVisitas/GetList?sucursal_Id=${getDataSession('sucursal')}&agente_id=${agente}&fecha_inicio=${fechaInicio}&fecha_fin=${fechaFin}&tipo=${filtro}&filtroFecha${filtroFecha}&tipo_visita_id=${tipoVisita}`} />
            </div>
        </div>
        <Modal isOpen={isOpenModal} closeModal={closeModal}>
            <br /><br />
            <div key={modalKey} className='col-md-12 row'>
                <div className='col-md-1' />
                <div className='col-md-11'>
                    <div className='col-md-12 row'>
                        <div className='col-md-4'>
                            <h4>Cliente</h4>
                            <label>Cliente:</label><p>&nbsp;&nbsp;&nbsp;{vxVisita?.cliente?.nombre}</p>
                            <label>Telefono:</label><p>&nbsp;&nbsp;&nbsp;{vxVisita?.cliente?.telefono1}</p>
                            <label>Correo:</label><p>&nbsp;&nbsp;&nbsp;{vxVisita?.cliente?.correo}</p>
                        </div>
                        <div className='col-md-4'>
                            <h4>Visita</h4>
                            <label>Fecha Planeada:</label><p>&nbsp;&nbsp;&nbsp;{vxVisita?.fecha_Planeada?.substring(0, 10)}</p>
                            <label>Fecha Hora Inicial:</label><p>&nbsp;&nbsp;&nbsp;{vxVisita?.fecha_Hora_Inicial}</p>
                            <label>Fecha Hora Final:</label><p>&nbsp;&nbsp;&nbsp;{vxVisita?.fecha_Hora_Final}</p>
                            {vxVisita && vxVisita?.vx_TipoVisita && (<label>Tipo Visita:</label>)}
                            {vxVisita && vxVisita?.vx_TipoVisita && (<p>&nbsp;&nbsp;&nbsp;{GetTipoVisita(vxVisita?.vx_TipoVisita)}</p>)}
                        </div>
                        <div className='col-md-4'>
                            <h4>Datos</h4>
                            <label>Razon Vis. Infec.:</label><p>&nbsp;&nbsp;&nbsp;{vxVisita?.razon_Vis_Infec}</p>
                            <label>Observaciones:</label><p>&nbsp;&nbsp;&nbsp;{vxVisita?.observaciones}</p>
                            <label>Estatus:</label><p>&nbsp;&nbsp;&nbsp;{vxVisita?.estatus}</p>
                        </div>
                    </div>
                    <br />
                    <div className='col-md-12'>
                        <div className='col-md-12 row'>
                            <div className='col-md-4' />
                            <h4 className='col-md-4'><label>Movimientos Visitas</label></h4>
                            <div className='col-md-4' />
                        </div>
                        <br />
                        {vxVisita?.movimientos?.map(x => {
                            return (<div className='row' style={{ border: "1px solid black" }}>
                                <div className='col-md-4'><label>Folio:</label><p>{x?.folio}</p></div>
                                <div className='col-md-4'><label>Movimiento:</label><p>{x?.movimiento}</p></div>
                                <div className='col-md-4'><label>Fecha Registro:</label><p>{x?.fecha_Registro}</p></div>
                            </div>);
                        })}
                    </div>
                </div>
            </div>
            <br />
        </Modal>
    </>);
}

export { List };